module.exports = __webpack_public_path__ + "img/diagram_mobile.c5afd43b.svg";